<template>
  <div>
    <div>
      <h5 class="py-3">選擇浮水印圖片</h5>
      <el-select v-model="waterMarkImageFileName" class="m-2" placeholder="Select" id="modeVertical" clearable>
        <el-option v-for="item in watermarkImages" :key="item.value" :label="item.label"
                   :value="item.value" />
      </el-select>
    </div>
    <div>
      <label class="py-3">透明度控制</label>
      <div class="d-flex">
        <el-slider v-model="wmOpacity" />
        <input class="w-25 ms-3" type="number" name="" id="" v-model="wmOpacity">
      </div>
    </div>
    <div class="py-2 ">
      <label class="py-3">陰影控制</label>
      <div class="d-flex">
        <el-slider v-model="wmShadow" />
        <input class="w-25 ms-3" type="number" name="" id="wmShadow" v-model="wmShadow">
      </div>
    </div>
    <div class="py-2">
      <label class="py-3">水平位置</label>
      <div class="d-flex">
        <el-slider v-model="wmHorizontal" />
        <input class="w-25 ms-3" type="number" name="" id="wmHorizontal" v-model="wmHorizontal">
      </div>
    </div>
    <div class="py-2">
      <label class="py-3">垂直位置</label>
      <div class="d-flex">
        <el-slider v-model="wmVertical" />
        <input class="w-25 ms-3" type="number" name="" id="wmVertical" v-model="wmVertical">
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import freeImg from "@/utils/freeImg";

const {watermarkImages} = freeImg()

const props = defineProps({
  wmOpacity: {
    type: Number,
    default: 50
  },
  wmHorizontal: {
    type: Number,
    default: 50
  },
  wmVertical: {
    type: Number,
    default: 50
  },
  wmShadow: {
    type: Number,
    default: 50
  },
  waterMarkImageFileName: {
    type: String,
    default: ''
  }
})
const emits = defineEmits([
    'update:wmOpacity',
  'update:wmHorizontal',
  'update:wmVertical',
  'update:wmShadow',
  'update:waterMarkImageFileName',
])


const wmOpacity = computed({
  get () {return props.wmOpacity},
  set (newValue) {
    emits('update:wmOpacity', newValue)
  }
})
const wmHorizontal = computed({
  get () {return props.wmHorizontal},
  set (newValue) {
    emits('update:wmHorizontal', newValue)
  }
})
const wmVertical = computed({
  get () {return props.wmVertical},
  set (newValue) {
    emits('update:wmVertical', newValue)
  }
})
const wmShadow = computed({
  get () {return props.wmShadow},
  set (newValue) {
    emits('update:wmShadow', newValue)
  }
})

const waterMarkImageFileName = computed({
  get() {return props.waterMarkImageFileName},
  set(newValue) {
    emits('update:waterMarkImageFileName', newValue)
  }
})
</script>
